import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'app-css-spinner',
	templateUrl: './css-spinner.component.html',
	styleUrls: ['./css-spinner.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CssSpinnerComponent {}
